import { render, staticRenderFns } from "./CorrectAnswersPopup.vue?vue&type=template&id=50783a45&"
import script from "./CorrectAnswersPopup.vue?vue&type=script&lang=js&"
export * from "./CorrectAnswersPopup.vue?vue&type=script&lang=js&"
import style0 from "./CorrectAnswersPopup.vue?vue&type=style&index=0&id=50783a45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports